import { useEffect, useCallback } from 'react';
export default function TicketRedirect({ ostype = '' }) {
  const sendMessage = useCallback(() => {
    window.webkit.messageHandlers.toggleMessageHandler.postMessage({
      message: 'done',
    });
  }, []);

  useEffect(() => {
    window.onload = sendMessage;
  }, [sendMessage]);

  return <div>Redirect...{ostype}</div>;
}
